import Swal from "sweetalert2";
import AXIOS from "../../config/axios"

const fetchSizeList = async () => {
    try {
        const res = await AXIOS.get('/lockers/size/list');
        return res.data
    } catch (error) {
        console.log(error)
        Swal.fire(error.message)
    }
}

export default fetchSizeList;